import { render } from "./doubts.vue?vue&type=template&id=36ca5f85&scoped=true"
import script from "./doubts.vue?vue&type=script&lang=js"
export * from "./doubts.vue?vue&type=script&lang=js"

import "./doubts.vue?vue&type=style&index=0&id=36ca5f85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ca5f85"]])

export default __exports__